/**
 * All application routes are collected here
 */
export const ROUTE_LOGIN = 'login';
export const ROUTE_INVITE = 'invite';
export const ROUTE_DASHBOARD = 'dashboard';
export const ROUTE_HOME = 'home';
export const ROUTE_DRIVER = 'driver';
export const ROUTE_COMPANY = 'company';
export const ROUTE_TAXI = 'taxi';
export const ROUTE_RIDE = 'ride';
export const ROUTE_BILLING = 'billing';
export const ROUTE_STATISTICS = 'statistics';
export const ROUTE_TRANSACTIONS = 'transactions';
export const ROUTE_MANAGER_MANAGEMENT = 'managers';
export const ROUTE_SHARE_MANAGEMENT = 'share-management';
export const ROUTE_NOTIFICATIONS = 'notifications';
export const ROUTE_PROMOTERS = 'promoters';
export const ROUTE_DRIVER_SEARCH = 'driver-search';
export const ROUTE_SMS_MONITOR = 'sms-monitor';
export const ROUTE_CITY_FAVORITES = 'city-favorites';
export const ROUTE_MODERATION = 'moderation';
export const ROUTE_ACTIVITY_LOG = 'activity-log';
export const ROUTE_LIVE_COUNTS = 'live-counts';
export const ROUTE_CUSTOMERS = 'customers';

// TODO: removed for now, maybe reintroduced later
// export const ROUTE_TRASH_BIN = 'trash-bin';
